import i18next from "i18next";

export const getLocalStorageData = (key) => {
  return localStorage.getItem(key);
};

export const setLocalStorageData = (key, value) => {
  localStorage.setItem(key, value);
};

export const clearLocalStorageData = () => {
  localStorage.clear();
};

export const removeLocalStorageParticularKey = (key) => {
  localStorage.removeItem(key);
};

export const getSessionJSON = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    return value ? value : null;
  } catch (error) {
    console.error(`Invalid JSON in sessionStorage for key: ${key}`, error);
    return null;
  }
};

export const setSessionJSON = (key, data) => {
  try {
    sessionStorage.setItem(key, data);
  } catch (error) {
    console.error(
      `Failed to set JSON in sessionStorage for key: ${key}`,
      error
    );
  }
};

export const getCountryText = (allowedCountries = [], t) => {
  if (allowedCountries.length === 0) {
    return t ? t("past_tournament_tab.all_regions") : "All Regions";
  }

  if (allowedCountries.length === 1) {
    return i18next.language === "ar" &&
      allowedCountries[0]?.name === "Gulf Cooperation Council"
      ? "مجلس التعاون الخليجي"
      : i18next.language === "en" &&
        allowedCountries[0]?.name === "Gulf Cooperation Council"
        ? "GCC"
        : allowedCountries[0]?.name;
  }

  if (allowedCountries.length === 2) {
    return allowedCountries
      .map((country) =>
        i18next.language === "ar" &&
          country?.name === "Gulf Cooperation Council"
          ? "مجلس التعاون الخليجي"
          : i18next.language === "en" &&
            country?.name === "Gulf Cooperation Council"
            ? "GCC"
            : country?.name
      )
      .join(" - ");
  }

  return allowedCountries
    .map((country) =>
      i18next.language === "ar" && country?.alpha2Code === "GCC"
        ? "مجلس التعاون الخليجي"
        : i18next.language === "en" && country?.alpha2Code === "GCC"
          ? "GCC"
          : country?.alpha2Code
    )
    .join(" - ");
};

export const splitTextIntoChunks = (text) => {
  const words = text.split(" ");
  let chunks = [];
  for (let i = 0; i < words.length; i += 3) {
    chunks.push(words.slice(i, i + 3).join(" "));
  }
  return chunks || " ";
};


export const shouldShowRewardPopup = (STORAGE_KEY) => {
  const today = new Date().toISOString().slice(0, 10);
  const lastSeen = localStorage.getItem(STORAGE_KEY);

  return lastSeen !== today;
};

export const markRewardPopupSeen = (STORAGE_KEY) => {
  const today = new Date().toISOString().slice(0, 10);
  localStorage.setItem(STORAGE_KEY, today);
};
